import { userDB, limitRefDB } from '@/firestoreDB'
import store from '@/store'

export const getUserPostsRefsPage = (lastValue) => {
  return paginateUserList('publications', 'score', 'desc', lastValue)
}

export const getUserLikesRefsPage = (lastValue) => {
  return paginateUserListWhere('publications', 'like_at', 'desc', lastValue, ['like', '==', true])
}

export const getUserAuthorPostsRefsPage = (lastValue, author) => {
  return paginateUserListWhere('publications', 'score', 'desc', lastValue, ['author_name', '==', author])
}

export const getUserNotifsRefsPage = (lastValue) => {
  return paginateUserList('notifications', 'score', 'desc', lastValue)
}

export const getUserTagNamesRefsPage = (lastValue, tagName) => {
  return paginateUserListWhere('publications', 'score', 'desc', lastValue, ['tags', 'array-contains', tagName])
}

export const paginateUserList = (collection, sortField, sortOrder, lastValue) => {
  const uuid = store.getters.firebaseUUID()
  let paginatedList = null
  if (lastValue) {
    paginatedList = userDB
      .doc(uuid)
      .collection(collection)
      .orderBy(sortField, sortOrder)
      .startAfter(lastValue)
      .limit(limitRefDB)
  } else {
    paginatedList = userDB
      .doc(uuid)
      .collection(collection)
      .orderBy(sortField, sortOrder)
      .limit(limitRefDB)
  }
  return paginatedList
}

export const paginateUserListWhere = (collection, sortField, sortOrder, lastValue, where) => {
  const uuid = store.getters.firebaseUUID()
  let paginatedList = null
  if (lastValue) {
    paginatedList = userDB
      .doc(uuid)
      .collection(collection)
      .where(where[0], where[1], where[2])
      .orderBy(sortField, sortOrder)
      .startAfter(lastValue)
      .limit(limitRefDB)
  } else {
    paginatedList = userDB
      .doc(uuid)
      .collection(collection)
      .where(where[0], where[1], where[2])
      .orderBy(sortField, sortOrder)
      .limit(limitRefDB)
  }
  return paginatedList
}



// WEBPACK FOOTER //
// ./src/helper/paginate.js